import { SubscriptionPlan } from '@aibees/shared/definition';
import { usePlanMetadata } from '@aibees/shared/features/price-and-plan/hooks/use-plan-metadata';
import { classnames } from '@aibees/shared/utils';
import { Box, CardHeader, Typography } from '@mui/material';
import { memo } from 'react';
import { CurrentPlanFeatures } from './components/current-plan-features';
import { PlanRules } from './components/plan-rules';
import { CurrentPlanInfo } from './components/plan-rules/components/current-plan-info';
import * as Styled from './styles';
import * as SX from './sx';
import type { CurrentPlanBenefitsProps as Props } from './types';

export const CurrentPlanBenefits = memo(
  ({ className, currentPlan, subscriptionType }: Props) => {
    const plan = currentPlan?.plan as unknown as SubscriptionPlan;

    const features = usePlanMetadata(plan, 'feature');

    return (
      <Styled.Wrapper
        className={classnames('CurrentPlanBenefits', className)}
        sx={SX.root}
        variant="outlined"
      >
        <CardHeader
          title={
            <Typography variant="body2" fontWeight={700} color="primary.600">
              Benefits
            </Typography>
          }
          sx={SX.header}
        />

        <Box sx={SX.content}>
          <Box sx={SX.box}>
            <CurrentPlanFeatures features={features} />
          </Box>
          <Box sx={SX.borderedBox}>
            <PlanRules
              currentPlan={currentPlan}
              subscriptionType={subscriptionType}
            />
            {/* <NextPlan currentPlan={currentPlan} /> */}
            <CurrentPlanInfo />
          </Box>
        </Box>
      </Styled.Wrapper>
    );
  }
);

CurrentPlanBenefits.displayName = 'CurrentPlanBenefits';
